import { render, staticRenderFns } from "./indexClient.vue?vue&type=template&id=44554108&scoped=true"
import script from "./indexClient.vue?vue&type=script&lang=js"
export * from "./indexClient.vue?vue&type=script&lang=js"
import style0 from "./indexClient.vue?vue&type=style&index=0&id=44554108&prod&lang=scss"
import style1 from "./indexClient.vue?vue&type=style&index=1&id=44554108&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44554108",
  null
  
)

export default component.exports